export const CONSUMER_DATA_PARAMS_PREFIX = 'data-hc-';
export const PRODUCTION_ENVIRONMENT_NAME = 'Production';
